import { Injectable } from "@angular/core";
import { AbstractControl, UntypedFormControl, ValidatorFn, Validators } from "@angular/forms";

import { PERIOD_FIELDS, periodLimitAmountValidator } from "../../../validators/period-limit-amount.validator";

import { MaximumDepositLimitConfig } from "./maximum-deposit-limit.config";
import { PERIOD_NAMES } from "./maximum-deposit-limit.const";
import { Periods } from "./maximum-deposit-limit.model";

@Injectable({
	providedIn: "root",
})
export class MaximumDepositLimitService {
	private depositLimits: Periods = {
		1: this.getDailyMaximumDepositLimit(),
		7: this.getWeeklyMaximumDepositLimit(),
		30: this.getMonthlyMaximumDepositLimit(),
	};

	constructor(private maximumDepositLimitConfig: MaximumDepositLimitConfig) {}

	setMaximumDepositLimit(
		amountControl: UntypedFormControl | AbstractControl,
		period: keyof Periods,
		defaultValidators?: ValidatorFn[]
	) {
		const maximumLimit = this.getMaximumDepositLimit(period);
		const { max, maxLength } = Validators;
		const depositLimitValidators = [
			max(maximumLimit),
			maxLength(12),
			periodLimitAmountValidator(PERIOD_FIELDS.deposit),
		];
		const combinedValidators = defaultValidators
			? [...depositLimitValidators, ...defaultValidators]
			: depositLimitValidators;
		amountControl.setValidators(combinedValidators);
	}

	convertNumericPeriodToWord(period: keyof Periods): string {
		return PERIOD_NAMES[period];
	}

	getMaximumDepositLimit(period: keyof Periods): number {
		return this.depositLimits[period];
	}

	isMaximumDepositLimitEnabled(): boolean {
		return this.maximumDepositLimitConfig.isMaximumDepositLimitEnabled();
	}

	getDailyMaximumDepositLimit(): number {
		return this.maximumDepositLimitConfig.getDailyDepositLimitMaxValue();
	}

	getWeeklyMaximumDepositLimit(): number {
		return this.maximumDepositLimitConfig.getWeeklyDepositLimitMaxValue();
	}

	getMonthlyMaximumDepositLimit(): number {
		return this.maximumDepositLimitConfig.getMonthlyDepositLimitMaxValue();
	}

	getMaximumDepositLimitThreshold(): number {
		return this.maximumDepositLimitConfig.getDepositLimitMaxThresholdValue();
	}
}
